import React, { useCallback, useState } from 'react'
import { Main, MainBody, MainTop, MainTopLeft, MainTopTitle } from '@/components/Layout'
import Resx from '@/components/Resx'
import context from '@/context'
import { BsrsGrid, Column, commandColumnProps } from '@/components/BsrsGrid'
import { useLocalization } from '@/hooks/localization'
import moment from 'moment'
import { Button } from '@/components/button'
import Icon from '@/components/Icon'
import { usePermissionChecker } from '@/hooks/usePermissionChecker'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { getStore } from '@/store'
import { dialogTypes } from '@/dialogs'

function ReportConstantCategoryList () {
  const { localize } = useLocalization()
  const isGranted = usePermissionChecker()

  const canEdit = isGranted('CanManageReportingConstants')

  const [lastReloadedAt, setLastReloadedAt] = useState(moment())

  const onDelete = useCallback(x =>
    context.api.reportConstantService.deleteCategory(x.id).then(() => setLastReloadedAt(moment())), [])

  const openEditDialog = useCallback((apiCall, item) => getStore().dispatch(dialogActions.openDialog({
    dialogType: dialogTypes.editConstantCategory,
    item: item,
    onAction: newItem => apiCall(newItem).then(setTimeout(() => setLastReloadedAt(moment()), 500))
  })), [])

  const onAddClick = useCallback(() => openEditDialog(context.api.reportConstantService.createCategory, {}),
    [openEditDialog])

  return <Main>
    <MainTop>
      <MainTopTitle><Resx name='Common.ReportConstants' /></MainTopTitle>
      {canEdit && <MainTopLeft>
        <Button color='primary' className='btn btn-md' onClick={onAddClick}>
          <Icon name='plus' />
          <Resx name={'Common.Add'} />
        </Button>
      </MainTopLeft>}
    </MainTop>
    <MainBody>
      <BsrsGrid lastReloadedAt={lastReloadedAt} defaultSort={[{ field: 'id', dir: 'asc' }]} dataSource={context.api.reportConstantService.getCategoriesList}>
        <Column field='id' title={localize('Common.Id')} editable={false} />
        <Column field='name' title={localize('Common.Name')} editable={false} />
        <Column field='latinName' title={localize('Common.LatinName')} editable={false} />
        <Column {...commandColumnProps({
          detailUrl: x => `/report-constant-categories/${x.id}`,
          deleteAction: onDelete,
          deleteDisabled: x => !(x.constantsCount === 0 && canEdit),
          editAction: x => openEditDialog(context.api.reportConstantService.updateCategory, x)
        })} title=' ' width={150} />
      </BsrsGrid>
    </MainBody>
  </Main>
}

export { ReportConstantCategoryList }



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/report-constants/index.js